import ExportButtonWithContext from './ExportButtonWithContext';

export default {
  ReactComponent: ExportButtonWithContext,
  bindings: {
    getData: '&',
    format: '@',
    filename: '@?',
    tooltipPlacement: '@?',
    text: '@?',
  },
  dependencies: ['Authentication'],
};
